import { getAuthenticatedUser, refreshAuthenticatedUser, logOutUser } from '../../thunk/auth';
import { EMPTY_AUTH, IAuth } from '../../types/auth';

const sameGroups = (a: string[] = [], b: string[] = []) => a.length === b.length && a.every((g, i) => g === b[i]);

export default {
    [getAuthenticatedUser.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getAuthenticatedUser.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data = action.payload;
    },
    [getAuthenticatedUser.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
        state.data = EMPTY_AUTH;
    },
    [refreshAuthenticatedUser.fulfilled as any]: (state, action) => {
        // A refresh that started before a sign-out must not bring the session back.
        if (!state.data.isLoggedIn) return;
        const next: IAuth = action.payload;
        if (!next.isLoggedIn) {
            state.data = next;
            return;
        }
        state.data.name = next.name;
        state.data.token = next.token;
        // Keep the `permissions` reference stable while the groups are unchanged (nav memos depend on it).
        if (!sameGroups(state.data.allRoles, next.allRoles)) {
            state.data.allRoles = next.allRoles;
            state.data.role = next.role;
            state.data.permissions = next.permissions;
        }
    },
    [refreshAuthenticatedUser.rejected as any]: (state, action) => {
        state.error = action.payload;
    },
    [logOutUser.pending as any]: (state) => {
        state.error = null;
    },
    // 'idle' so a later remount (sign-in without reload) starts with the loader, not a 404 frame.
    [logOutUser.fulfilled as any]: (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
    },
    [logOutUser.rejected as any]: (state, action) => {
        state.status = 'idle';
        state.error = action.payload;
        state.data = EMPTY_AUTH;
    },
}
